<div class="selection-section">
  <div>
    <div class="rift-soft">Bus(es)</div>
  </div>
  <curbnturf-input-plus-minus (valueChange)="updateBuses($event)" [value]="busCount" class="bus-count">
  </curbnturf-input-plus-minus>
</div>
<div>How many buses could fit in the space?</div>
<div class="_18-px-spacer"></div>
<div class="selection-section">
  <div>
    <div class="rift-soft">Car(S)</div>
  </div>
  <curbnturf-input-plus-minus (valueChange)="updateCars($event)" [value]="carCount" class="car-count">
  </curbnturf-input-plus-minus>
</div>
<div>How many cars could fit in the space?</div>
<div class="_18-px-spacer"></div>
<div class="horz-line"></div>
<div class="_18-px-spacer"></div>
<curbnturf-wheelchair-input [amenities]="amenities"> </curbnturf-wheelchair-input>
